import React, { useState } from "react";

const CheckAvailabilityTable = () => {
  const [searchParams, setSearchParams] = useState({
    checkIn: "",
    checkOut: "",
    guests: 1,
    rooms: 1,
    roomType: "All",
    priceRange: [0, 500],
    amenities: [],
  });

  const [results, setResults] = useState([]);
  const roomTypes = ["Single", "Double", "Suite"];
  const amenitiesOptions = ["Wi-Fi", "Pool", "Gym", "Free Breakfast"];
  
  const handleSearch = () => {
    // Fetch or filter results based on `searchParams`
    const mockResults = [
      {
        roomType: "Single",
        maxOccupancy: 2,
        price: 100,
        available: true,
        amenities: ["Wi-Fi", "Free Breakfast"],
      },
      {
        roomType: "Double",
        maxOccupancy: 4,
        price: 200,
        available: false,
        amenities: ["Wi-Fi", "Pool"],
      },
    ];
    setResults(mockResults);
  };

  return (
    <div className="check-availability">
      {/* Search Criteria Section */}
      <div className="search-criteria">
        <h2>Check Availability</h2>
        <form>
          <label>
            Check-In Date:
            <input
              type="date"
              value={searchParams.checkIn}
              onChange={(e) => setSearchParams({ ...searchParams, checkIn: e.target.value })}
            />
          </label>
          <label>
            Check-Out Date:
            <input
              type="date"
              value={searchParams.checkOut}
              onChange={(e) => setSearchParams({ ...searchParams, checkOut: e.target.value })}
            />
          </label>
          <label>
            Guests:
            <input
              type="number"
              min="1"
              value={searchParams.guests}
              onChange={(e) => setSearchParams({ ...searchParams, guests: e.target.value })}
            />
          </label>
          <label>
            Rooms:
            <input
              type="number"
              min="1"
              value={searchParams.rooms}
              onChange={(e) => setSearchParams({ ...searchParams, rooms: e.target.value })}
            />
          </label>
          <label>
            Room Type:
            <select
              value={searchParams.roomType}
              onChange={(e) => setSearchParams({ ...searchParams, roomType: e.target.value })}
            >
              <option value="All">All</option>
              {roomTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </label>
          <label>
            Price Range:
            <input
              type="range"
              min="0"
              max="500"
              step="10"
              value={searchParams.priceRange[1]}
              onChange={(e) =>
                setSearchParams({ ...searchParams, priceRange: [0, e.target.value] })
              }
            />
            <span>${searchParams.priceRange[1]}</span>
          </label>
          <fieldset>
            <legend>Amenities:</legend>
            {amenitiesOptions.map((amenity) => (
              <label key={amenity}>
                <input
                  type="checkbox"
                  value={amenity}
                  checked={searchParams.amenities.includes(amenity)}
                  onChange={(e) => {
                    const updatedAmenities = e.target.checked
                      ? [...searchParams.amenities, amenity]
                      : searchParams.amenities.filter((a) => a !== amenity);
                    setSearchParams({ ...searchParams, amenities: updatedAmenities });
                  }}
                />
                {amenity}
              </label>
            ))}
          </fieldset>
          <button type="button" onClick={handleSearch}>
            Search
          </button>
        </form>
      </div>

      {/* Results Table */}
      <div className="results-table">
        <h3>Available Rooms</h3>
        {results.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Room Type</th>
                <th>Max Occupancy</th>
                <th>Price (per night)</th>
                <th>Availability</th>
                <th>Amenities</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {results.map((room, index) => (
                <tr key={index}>
                  <td>{room.roomType}</td>
                  <td>{room.maxOccupancy}</td>
                  <td>${room.price}</td>
                  <td>{room.available ? "Available" : "Fully Booked"}</td>
                  <td>{room.amenities.join(", ")}</td>
                  <td>
                    {room.available && <button>Book Now</button>}
                    <button>View Details</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No rooms found. Adjust your search criteria.</p>
        )}
      </div>
    </div>
  );
};

export default CheckAvailabilityTable;
